import React from 'react';
import './PricingModel.css';

const PricingModel = () => {
  return (
    <section className="pricing-section">
      <h2 className="pricing-title">Our Pricing Plans</h2>
      <p className="pricing-subtitle">
        Haute-u AR offers flexible plans to empower your fashion journey with the latest in Gen-AI, AR Try-On, and personalized recommendations.
      </p>
      <div id = "pricing" className="pricing-image">
      <div className="pricing-grid">
        <div className="pricing-card">
          <h3>Starter</h3>
          <p className="price">Free</p>
          <ul className="pricing-features">
            <li>✓ Try-on with limited wardrobe (clothing + jewelry)</li>
            <li>✓ Skin tone-based style previews</li>
            <li>✓ 3 body scans/month</li>
            <li>✓ Limited access to AI chat stylist</li>
            <li>✗ No measurement tools or wardrobe saving</li>
          </ul>
        </div>

        <div className="pricing-card highlighted">
          <h3>Pro</h3>
          <p className="price">$9.99/month</p>
          <ul className="pricing-features">
            <li>✓ Unlimited virtual try-ons (clothing )</li>
            <li>✓ Advanced AI stylist with Gen-AI chat</li>
            <li>✓ Body measurement via AI scan</li>
            <li>✓ Skin tone & body shape outfit curation</li>
            <li>✓ Save & share wardrobe fits</li>
            <li>✓ Access to new seasonal drops first</li>
          </ul>
        </div>
                <div className="pricing-card">
          <h3>Pro Plus</h3>
          <p className="price">$19.99/month</p>
          <ul className="pricing-features">
            <li>✓ Unlimited virtual try-ons (clothing + jewelry)</li>
            <li>✓ Advanced AI stylist with Gen-AI chat</li>
            <li>✓ Body measurement via AI scan</li>
            <li>✓ Skin tone & body shape outfit curation</li>
            <li>✓ Save & share wardrobe fits</li>
            <li>✓ Access to new seasonal drops first</li>
            <li>✓ Personalized Gen-AI recommendations</li>
            <li>✓ 10 body scans/month</li> 
            <li>✓ 5 wardrobe saving</li>
            <li>✓ Existing wardrobe scan addition for recommendations</li>
            <li>✓ 5 AI chat stylist</li>
          </ul>
        </div>
        <div className="pricing-card">
          <h3>Enterprise</h3>
          <p className="price">Custom</p>
          <ul className="pricing-features">
            <li>✓ White-labeled experience for retailers</li>
            <li>✓ Everything on Pro Plus Plans</li>  
            <li>✓ API Access for VTON & AI engine</li>
            <li>✓ Custom Gen-AI recommendations per brand</li>
            <li>✓ Jewelry & clothing integration with branding</li>
            <li>✓ Analytics & usage dashboard</li>
            <li>✓ Dedicated onboarding & support</li>
          </ul>
        </div>
      </div>
      </div>
      <p className="pricing-note">
        * All plans include access to our mobile app and web platform. 
        Upgrade or cancel anytime.  </p>
    </section>
  );
};

export default PricingModel;
